import { observer } from 'mobx-react-lite';

import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import TextField from '../../../../../shared/components/TextField';
import rootStore from '../../../rootStore/RootStore';

const TaxIdInput = observer(() => {
  const { t } = useTranslation();
  const { userStore } = rootStore;
  const { selectedCountryInfo, saveCustomer } = rootStore.userStore;

  const errorText = useMemo(() => {
    if (!saveCustomer.error) {
      return '';
    }

    const regex = new RegExp(selectedCountryInfo.taxIdType);

    // Example error message:
    // Request req_yihUJtHEmtZbuS: Invalid value for eu_vat.
    if (!regex.test(saveCustomer.error.message)) {
      return '';
    }

    return t('user-contacts.errors.tax-id');
  }, [saveCustomer.error, selectedCountryInfo, t]);

  const handleTaxIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    userStore.setTaxId(event.target.value);
  };

  if (!selectedCountryInfo?.taxIdType) {
    return null;
  }

  return (
    <TextField
      styles={{ formControl: { mt: 1 } }}
      label={selectedCountryInfo.description}
      placeholder={selectedCountryInfo.taxIdExample}
      error={!!errorText}
      helperText={errorText}
      onChange={handleTaxIdChange}
    />
  );
});

export default TaxIdInput;
